'use client';

import { useEffect } from 'react';

import { initSentryBoot } from '@/lib/sentry';

/**
 * Sentry-инициализация максимально откладывается, чтобы не конкурировать
 * с критическими чанками за CPU на холодном старте. На iPhone 12 это даёт
 * ~150–300 мс выигрыша до первого интерактивного состояния.
 */
export function SentryBootInit() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const idle = (cb: () => void) => {
      const ric = (window as Window & {
        requestIdleCallback?: (cb: IdleRequestCallback, options?: { timeout?: number }) => number;
      }).requestIdleCallback;
      if (typeof ric === 'function') {
        ric(() => cb(), { timeout: 4000 });
        return;
      }
      window.setTimeout(cb, 1500);
    };

    idle(() => {
      try {
        initSentryBoot();
      } catch {
        // never let telemetry init crash the app
      }
    });
  }, []);

  return null;
}
